function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 10.8333C10.4604 10.8333 10.8335 10.4602 10.8335 9.99996C10.8335 9.53972 10.4604 9.16663 10.0002 9.16663C9.53993 9.16663 9.16683 9.53972 9.16683 9.99996C9.16683 10.4602 9.53993 10.8333 10.0002 10.8333Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8335 10.8333C16.2937 10.8333 16.6668 10.4602 16.6668 9.99996C16.6668 9.53972 16.2937 9.16663 15.8335 9.16663C15.3733 9.16663 15.0002 9.53972 15.0002 9.99996C15.0002 10.4602 15.3733 10.8333 15.8335 10.8333Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.16683 10.8333C4.62707 10.8333 5.00016 10.4602 5.00016 9.99996C5.00016 9.53972 4.62707 9.16663 4.16683 9.16663C3.70659 9.16663 3.3335 9.53972 3.3335 9.99996C3.3335 10.4602 3.70659 10.8333 4.16683 10.8333Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHorizontalEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalEllipsis);
export default __webpack_public_path__ + "static/media/horizontal-ellipsis.cd0d69d1.svg";
export { ForwardRef as ReactComponent };